import dayjs from 'dayjs'
import React from 'react'

import { RelativeTime } from '@hozana/intl/RelativeTime'

import { Label, TLabelProps } from 'elements/ui/Label'

import { COMMUNITY_ACTIVITY, COMMUNITY_LIFETIME, COMMUNITY_STATUS } from 'modules/community/constants'
import { useCommunityFrequency } from 'modules/community/hooks/useCommunityFrequency'
import type { TCommunity } from 'modules/community/types'

export type TCommunityActivityStatusLabelsProps = {
  community: TCommunity
} & TLabelProps

export const CommunityActivityStatusLabels: TFCC<TCommunityActivityStatusLabelsProps> = ({
  community,
  ...otherProps
}) => {
  const { frequencyText } = useCommunityFrequency({ community })
  let text: JSX.Element | string
  let labelStatus: TLabelProps['colors']

  if ([COMMUNITY_STATUS.CHECK, COMMUNITY_STATUS.DRAFT].includes(community.status)) {
    switch (community.status) {
      case COMMUNITY_STATUS.CHECK:
        text = 'trans:community:community.status.check.validating'
        labelStatus = 'success'
        break
      case COMMUNITY_STATUS.DRAFT:
        text = 'trans:community:community.status.draft.word'
        labelStatus = 'neutral'
        break

      default:
        break
    }
  } else {
    switch (community.activity) {
      case COMMUNITY_ACTIVITY.ONGOING:
        text = 'trans:community:words.ongoing'
        labelStatus = 'success'
        break
      case COMMUNITY_ACTIVITY.COMING_SOON:
        text = (
          <RelativeTime
            date={community.fromDate}
            // minDate = tomorrow if coming soon
            minDate={dayjs().add(1, 'day')}
            updateInterval={3600}
          />
        )
        labelStatus = 'important'
        break
      case COMMUNITY_ACTIVITY.ACTIVE:
        labelStatus = 'success'
        text = frequencyText
        break
      case COMMUNITY_ACTIVITY.INACTIVE:
        text = 'trans:community:community.activity.inactive'
        labelStatus = 'neutral'
        break

      default:
        break
    }
  }

  const communityLifetimeLabelText = {
    [COMMUNITY_LIFETIME.NOVENA]: 'community:word.novena',
    [COMMUNITY_LIFETIME.RETREAT]: 'community:word.retreat',
    [COMMUNITY_LIFETIME.EVERLASTING]: undefined,
  }[community.lifetime]

  return (
    <>
      {communityLifetimeLabelText && (
        <Label colors="info" {...otherProps}>
          {communityLifetimeLabelText}
        </Label>
      )}
      {text && (
        <Label colors={labelStatus} {...otherProps}>
          {text}
        </Label>
      )}
    </>
  )
}
